import React from 'react';
import { Dropdown } from './Dropdown';
import { TIMEFRAMES, MEXC_SUPPORTED_TFS } from 'data/analysisDisplay';

interface TimeframeSelectProps {
  open: boolean;
  anchor: HTMLElement | null;
  selected: string;
  exchange: 'binance' | 'mexc';
  onSelect: (tag: string) => void;
  onClose: () => void;
}

export function TimeframeSelect({
  open,
  anchor,
  selected,
  exchange,
  onSelect,
  onClose,
}: TimeframeSelectProps) {
  // MEXC rejects several timeframes (12H, 3D…) — hide them from the picker.
  const options =
    exchange === 'mexc' ? TIMEFRAMES.filter((tf) => MEXC_SUPPORTED_TFS.has(tf.tag)) : TIMEFRAMES;

  return (
    <Dropdown open={open} anchor={anchor} onClose={onClose} width={150}>
      {options.map((tf) => {
        const active = tf.tag === selected;
        return (
          <button
            key={tf.tag}
            type="button"
            className={`tf-item${active ? ' active' : ''}`}
            onClick={() => {
              onSelect(tf.tag);
              onClose();
            }}
          >
            <span className="tf-item-text">{tf.label}</span>
            <span className={`tf-item-tag${active ? ' active' : ''}`}>{tf.tradingStyle}</span>
          </button>
        );
      })}
    </Dropdown>
  );
}
